import { DigitalTwinTranslations } from 'api/digitalTwin/digitalTwin.api'
import React, { ReactElement } from 'react'
import authStore from 'store/auth/auth'
import { systemFeatureFlagActive } from 'utils/systemUtils'
import { useSnapshot } from 'valtio'
import styles from './DigitalTwinAccumulatorLevels.module.less'
import { SingleDigitalTwinAccumulatorLevel } from './SingleDigitalTwinAccumulatorLevel'

export type OnEditAccumulatorLevel = { onEdit: () => void; hasPermission: boolean }

export type AggregatedAccumulatorData = {
  unitName: string
  startLevelValue: number
  startLevelWarnings: string[]
  onEditStartLevelClicked?: OnEditAccumulatorLevel
  endLevelValue: number
  endLevelWarnings: string[]
  onEditEndLevelClicked?: OnEditAccumulatorLevel
}

type LevelsForOneDigitalTwinAccumulatorProps = {
  digitalTwinTranslations?: DigitalTwinTranslations
  accumulatorData: AggregatedAccumulatorData
}

export function LevelsForOneDigitalTwinAccumulator({
  digitalTwinTranslations,
  accumulatorData: aggregatedData,
}: LevelsForOneDigitalTwinAccumulatorProps): ReactElement {
  const { activeSystem } = useSnapshot(authStore)
  const hideAccEndLevels = systemFeatureFlagActive(activeSystem, 'hide_acc_end_level_info') // Hide accumulator level information if the 'hide_acc_end_level_info' feature flag is active for the current system.

  return (
    <div className={styles.DigitalTwinAccumulatorLevels_AccumulatorLevels}>
      <SingleDigitalTwinAccumulatorLevel
        value={aggregatedData.startLevelValue}
        accumulatorName={aggregatedData.unitName}
        attribute="start_level"
        onEditClicked={aggregatedData.onEditStartLevelClicked?.onEdit}
        hasEditPermission={aggregatedData.onEditStartLevelClicked?.hasPermission ?? false}
        digitalTwinTranslations={digitalTwinTranslations}
        warnings={aggregatedData.startLevelWarnings}
      />
      {!hideAccEndLevels && (
        <SingleDigitalTwinAccumulatorLevel
          value={aggregatedData.endLevelValue}
          accumulatorName={aggregatedData.unitName}
          attribute="end_level"
          onEditClicked={aggregatedData.onEditEndLevelClicked?.onEdit}
          hasEditPermission={aggregatedData.onEditEndLevelClicked?.hasPermission ?? false}
          digitalTwinTranslations={digitalTwinTranslations}
          warnings={aggregatedData.endLevelWarnings}
        />
      )}
    </div>
  )
}
